import React from "react";
import { SlideService } from "../../components/servicesListe/slideSerice";
import img from "../../assets/images/consulting.png";
import ServicesSection from "../../components/servicesListe/servicesSection";
import { MOAIcon } from "../../assets/icons/MOAIcon";
import { TechnologiesIcon } from "../../assets/icons/TechnologiesIcon";
import { PHPIcon } from "../../assets/icons/PHPIcon";
import { InfrastructureIcon } from "../../assets/icons/InfrastructureIcon";
import { BigDataIcon } from "../../assets/icons/BigDataIcon";
const services = [
  {
    title: "MOA / MOE / QA",
    description: "Accompagnement projet, coordination, assurance qualité",
    icon: <MOAIcon />,
    variant: "white",
  },
  {
    title: "Nouvelles technologies",
    description: "Conseil en innovation, choix technos, intégration",
    icon: <TechnologiesIcon />,
    variant: "green",
  },
  {
    title: "Décisionnel",
    description: "Mise en place de systèmes de reporting et analyse",
    icon: <PHPIcon />,
    variant: "green",
  },
  {
    title: "Infrastructure / Exploitation",
    description: "Audit, amélioration de l’environnement IT",
    icon: <InfrastructureIcon />,
    variant: "white",
  },
  {
    title: "Big Data",
    description: "Stratégie data",
    icon: <BigDataIcon />,
    variant: "white",
  },
];
export const ConsultingPage = () => {
  return (
    <div>
      <SlideService
        title={"Consulting"}
        description={
          "Du diagnostic à la mise en œuvre opérationnelle, notre cabinet de conseil vous accompagne à chaque étape."
        }
        img={img}
      />

      <ServicesSection services={services} />
    </div>
  );
};
